import {
  FETCH_ORDERS,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAILURE,
  DELETE_ORDERS,
  DELETE_ORDERS_SUCCESS,
  DELETE_ORDERS_FAILURE,
  TOGGLE_DOC_MODAL,
  TOGGLE_DETAIL_MODAL,
  UPDATE_DOC,
  UPDATE_DOC_SUCCESS,
  ORDER_APPROVE_SUCCESS,
  UPDATE_DOC_FAILURE,
  ADD_ORDER_ITEM,
  ADD_ORDER_ITEM_SUCCESS,
  ADD_ORDER_ITEM_FAILURE,
  UPDATE_DETAIL,
  UPDATE_DETAIL_SUCCESS,
  UPDATE_DETAIL_FAILURE
} from "./ordersAction";

const initialState = {
  items: [],
  isFetching: false,
  isDocModalOpen: false,
  isDetailModalOpen: false,
  order: {}
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_ORDERS:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        items: action.payload,
        isFetching: false
      };
    case FETCH_ORDERS_FAILURE:
      return {
        ...state,
        items: [],
        isFetching: false
      };
    case DELETE_ORDERS:
      return {
        ...state,
        isFetching: true
      };
    case DELETE_ORDERS_SUCCESS:
      //console.log(action.payload);
      let items = state.items.filter(obj => obj.order_id !== action.payload);
      //console.log();
      return {
        ...state,
        items: items,
        isFetching: false
      };
    case DELETE_ORDERS_FAILURE:
      return {
        ...state,
        isFetching: false
      };
    case TOGGLE_DOC_MODAL:
      return {
        ...state,
        isDocModalOpen: !state.isDocModalOpen,
        order: action.payload
      };
    case TOGGLE_DETAIL_MODAL:
      return {
        ...state,
        isDetailModalOpen: !state.isDetailModalOpen,
        order: action.payload
      };
    case UPDATE_DOC:
      return {
        ...state,
        isFetching: true
      };
    case UPDATE_DOC_SUCCESS:
      const temp_items = state.items.map(val => {
        if (val.order_id === action.payload.order_id) {
          return action.payload;
        }
        return { ...val };
      });
      return {
        ...state,
        order: {},
        items: temp_items,
        isFetching: false
      };
    case ORDER_APPROVE_SUCCESS:
      console.log('reduce ORDER_APPROVE_SUCCESS');
      return state

    case UPDATE_DOC_FAILURE:
      return {
        ...state,
        isFetching: false
      };
    case ADD_ORDER_ITEM:
      return {
        ...state,
        isFetching: true
      };
    case ADD_ORDER_ITEM_SUCCESS:
      return {
        ...state,
        isFetching: false
      };
    case ADD_ORDER_ITEM_FAILURE:
      return {
        ...state,
        isFetching: false
      };
    case UPDATE_DETAIL:
      return {
        ...state,
        isFetching: true
      };
    case UPDATE_DETAIL_SUCCESS:
      const temp_order_items = state.items.map(val => {
        if (val.order_id === action.payload.order_id) {
          return action.payload;
        }
        return { ...val };
      });
      return {
        ...state,
        order: {},
        items: temp_order_items,
        isFetching: false
      };
    case UPDATE_DETAIL_FAILURE:
      return {
        ...state,
        isFetching: false
      };
    default:
      return state;
  }
}
